import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, account }) =>
    present(
      repository
        .getProjectRole(account, project)
        .then((role) => ({ role, project, account }))
        .catch(() => Promise.reject({ project, account })),
    );
}

export type { Interactor };

export { createInteractor };
